module.exports = __webpack_public_path__ + "media/images/logo_mamekuru-b5a16c4edfde219a43850cee538b9254.png";